import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addCoupon = (FormData, setFormData, setCouponData) => {
  axiosInstance
    .post("/coupon/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Coupon added successfully") {
        toast.success("Coupon added");
        setFormData({
          code: "",
          discount: "",
          usageLimit: "",
          expirationDate: "",
          createdAt: new Date().toISOString(),
        });
        getCouponList(setCouponData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};

export const getCouponList = (setCouponData) => {
  axiosInstance
    .get("/coupon/list", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setCouponData(res.data.data);
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};

export const couponUpdate = (FormData, setFormData, setCouponData) => {
  axiosInstance
    .put("/coupon/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Coupon updated successfully") {
        toast.success("Coupon updated");
        setFormData({
          code: "",
          discount: "",
          usageLimit: "",
          expirationDate: "",
        });
        getCouponList(setCouponData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};

export const deleteCoupon = (id, setCouponData) => {
  axiosInstance
    .delete(
      "/coupon/delete",
      {
        data: { id: id },
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Coupon deleted successfully") {
        toast.success("Coupon deleted");
        getCouponList(setCouponData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};
